import ColaboradoresTabla from "#colaborador/pages/ColaboradoresTabla"
import { Fragment, useMemo, useState } from "react"
import Colaborador from "./Colaborador"
import { ChangeTitle } from "Components/menu/funciones"

const TablaColaboradores = () => {
	ChangeTitle("Colaboradores Cursos")
	const [colaboradores, setColaboradores] = useState([])
	const params = useMemo(() => ({ activos: true, mis_colaboradores: true }), [])
	const renderExpandableRow = (rowData, { dataIndex }) => {
		return (
			<tr>
				<td colSpan={6}>
					<Colaborador id={colaboradores[dataIndex]?.id} />
				</td>
			</tr>
		)
	}
	const customToolbar = () => (
		<Fragment>
			{/* <Tooltip
				title="Descargar Cursos"
				onClick={() => {
					setModalCursosZip(true)
				}}
			>
				<IconButton aria-label="delete">
					<SimCardDownloadIcon />
				</IconButton>
			</Tooltip>
			<Tooltip
				title="Actualizar Cursos"
				onClick={() => {
					putApiCursos("colaborador", token, {}, { actualizar: true })
				}}
			>
				<IconButton aria-label="delete">
					<CachedIcon />
				</IconButton>
			</Tooltip> */}
		</Fragment>
	)

	return (
		<ColaboradoresTabla
			{...{
				getData: setColaboradores,
				expandableRows: true,
				customToolbar,
				renderExpandableRow,
				params,
				filter: false,
				download: false,
				print: false,
			}}
		/>
	)
}

export default TablaColaboradores
